export const enum ObjectCategory {
  Tools = 'Tools',
  Museum = 'Museum'
}
